export default __webpack_public_path__ + "static/media/ilus2.c5cec28e.jpeg";